import React from "react";
import Layout from "../components/layout"
import KibanaScreenshot from "../images/kibana-screenshot.jpg";
import { Button } from "gatsby-theme-material-ui";

export default () => (
  <Layout>
    <div style={{ position: 'relative' }}>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <h1 className="is-size-1">Monitaur Charts and Graphs</h1>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <img className="is-centered" src={KibanaScreenshot} alt="Screenshot of the Monitaur Dashboard"></img>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <p className="is-size-3">
        Screenshot of the Monitaur Dashboard
      </p>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <p className="is-size-4">
        Customers can login to the dashboard here <a style={{ textDecoration: `none` }} href='https://kibana.monitaur.net/'><Button size='small' variant='contained' color='gold'  >login</Button></a>
      </p>
    </div>
    </div>
  </Layout>
);
